"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Article = void 0;
var uuid_1 = require("uuid");
var lib_1 = require("../lib");
var types_1 = require("../types");
var Article = /** @class */ (function () {
    function Article(_a) {
        var cardmarketArticle = _a.cardmarketArticle, attributes = _a.attributes, stockResponseArticle = _a.stockResponseArticle, quantity = _a.quantity, condition = _a.condition, idLanguage = _a.idLanguage, idProduct = _a.idProduct, price = _a.price, comment = _a.comment, isFoil = _a.isFoil, isPlayset = _a.isPlayset, isReverseHolo = _a.isReverseHolo, isSigned = _a.isSigned, isFirstEd = _a.isFirstEd, isAltered = _a.isAltered, idArticle = _a.idArticle, branded = _a.branded;
        this.branded = undefined;
        if (cardmarketArticle) {
            this.attributes = this.parseCardmarketArticle(cardmarketArticle);
        }
        else if (stockResponseArticle) {
            this.attributes = this.parseStockResponseArticle(stockResponseArticle);
        }
        else if (attributes) {
            this.attributes = attributes;
        }
        else if (idProduct) {
            this.attributes = [
                quantity !== null && quantity !== void 0 ? quantity : 1,
                condition !== null && condition !== void 0 ? condition : 'NM',
                idLanguage !== null && idLanguage !== void 0 ? idLanguage : types_1.CardLanguage.English,
                idProduct,
                price !== null && price !== void 0 ? price : 1000,
                comment !== null && comment !== void 0 ? comment : '',
                !!isFoil,
                !!isPlayset,
                !!isReverseHolo,
                !!isSigned,
                !!isFirstEd,
                idArticle !== null && idArticle !== void 0 ? idArticle : '',
                null,
                !!isAltered,
            ];
        }
        else {
            throw new Error('invalid data');
        }
        this.quantity = quantity !== null && quantity !== void 0 ? quantity : this.quantity;
        this.condition = condition !== null && condition !== void 0 ? condition : this.condition;
        this.idLanguage = idLanguage !== null && idLanguage !== void 0 ? idLanguage : this.idLanguage;
        this.price = price !== null && price !== void 0 ? price : this.price;
        this.comment = comment !== null && comment !== void 0 ? comment : this.comment;
        this.isFoil = isFoil !== null && isFoil !== void 0 ? isFoil : this.isFoil;
        this.isPlayset = isPlayset !== null && isPlayset !== void 0 ? isPlayset : this.isPlayset;
        this.isReverseHolo = isReverseHolo !== null && isReverseHolo !== void 0 ? isReverseHolo : this.isReverseHolo;
        this.isSigned = isSigned !== null && isSigned !== void 0 ? isSigned : this.isSigned;
        this.isFirstEd = isFirstEd !== null && isFirstEd !== void 0 ? isFirstEd : this.isFirstEd;
        this.isAltered = isAltered !== null && isAltered !== void 0 ? isAltered : this.isAltered;
        this.idArticle = idArticle !== null && idArticle !== void 0 ? idArticle : this.idArticle;
        this.idArticle = this.idArticle || (0, uuid_1.v4)();
        this.branded = branded;
        if (this.comment.includes('tcgpt') || this.comment.includes('TCGPowerTools')) {
            this.branded = true;
            if (this.comment.includes('|')) {
                this.comment = (0, lib_1.stripBrandingComment)(this.comment);
            }
            else {
                this.comment = '';
            }
        }
    }
    Object.defineProperty(Article.prototype, "quantity", {
        // Getter
        get: function () {
            return this.attributes[0];
        },
        set: function (value) {
            this.attributes[0] = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Article.prototype, "condition", {
        get: function () {
            return this.attributes[1];
        },
        set: function (value) {
            this.attributes[1] = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Article.prototype, "idLanguage", {
        get: function () {
            return this.attributes[2];
        },
        set: function (value) {
            this.attributes[2] = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Article.prototype, "idProduct", {
        get: function () {
            return this.attributes[3];
        },
        set: function (_value) {
            console.log('id product is not settable');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Article.prototype, "price", {
        get: function () {
            return this.attributes[4];
        },
        set: function (value) {
            this.attributes[4] = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Article.prototype, "comment", {
        get: function () {
            return this.attributes[5];
        },
        set: function (value) {
            this.attributes[5] = value.replace(/\;/g, '');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Article.prototype, "isFoil", {
        get: function () {
            return this.attributes[6] || false;
        },
        set: function (value) {
            this.attributes[6] = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Article.prototype, "isPlayset", {
        get: function () {
            return this.attributes[7] || false;
        },
        set: function (value) {
            this.attributes[7] = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Article.prototype, "isReverseHolo", {
        get: function () {
            return this.attributes[8] || false;
        },
        set: function (value) {
            this.attributes[8] = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Article.prototype, "isSigned", {
        get: function () {
            return this.attributes[9] || false;
        },
        set: function (value) {
            this.attributes[9] = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Article.prototype, "isFirstEd", {
        get: function () {
            return this.attributes[10] || false;
        },
        set: function (value) {
            this.attributes[10] = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Article.prototype, "idArticle", {
        get: function () {
            return this.attributes[11];
        },
        set: function (value) {
            this.attributes[11] = value !== null && value !== void 0 ? value : (0, uuid_1.v4)();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Article.prototype, "isAltered", {
        get: function () {
            return this.attributes[13] || false;
        },
        set: function (value) {
            this.attributes[13] = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Article.prototype, "realComment", {
        get: function () {
            if (this.branded) {
                return (0, lib_1.getBrandedComment)(this.comment);
            }
            else {
                return this.comment.trim() ? this.comment : '';
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Article.prototype, "realAttributes", {
        get: function () {
            var real = __spreadArray([], this.attributes, true);
            real[5] = this.realComment;
            real.push(this.branded);
            return real;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Article.prototype, "languageName", {
        get: function () {
            return types_1.CardLanguage[this.idLanguage];
        },
        set: function (value) {
            //@ts-ignore
            var newId = types_1.CardLanguage[value];
            if (!newId) {
                console.log("".concat(value, " not a valid language name"));
            }
            this.attributes[2] = newId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Article.prototype, "isShiny", {
        get: function () {
            return this.isFoil || this.isReverseHolo;
        },
        enumerable: false,
        configurable: true
    });
    Article.prototype.copy = function () {
        return new Article(__assign({}, this.toPlainObject()));
    };
    Article.prototype.setAttribute = function (attribute /* AttributeName */, value) {
        switch (attribute) {
            case 'quantity':
                if (!Number.isInteger(Number(value)) || Number(value) < 0)
                    console.log('quantity must be a not negative integer');
                else
                    this.quantity = Number(value);
                break;
            case 'idLanguage':
                if (!types_1.CardLanguage[value])
                    console.log('language not recognized');
                else
                    this.idLanguage = value;
                break;
            case 'condition':
                if (!types_1.CARDMARKET_CONDITIONS.find(function (condition) { return condition === value; }))
                    console.log('invalid condition');
                else
                    this.condition = value;
                break;
            case 'price':
                if (Number(value) <= 0)
                    console.log('price must be a positive number');
                else
                    this.price = Number(value);
                break;
            case 'comment':
                if (!(typeof value === 'string'))
                    console.log('comment must be a string');
                else
                    this.comment = value;
                break;
            case 'idArticle':
                console.log('idArticle cannot be changed');
                break;
            case 'isFoil':
                this.isFoil = !!value;
                break;
            case 'isPlayset':
                this.isPlayset = !!value;
                break;
            case 'isReverseHolo':
                this.isReverseHolo = !!value;
                break;
            case 'isSigned':
                this.isSigned = !!value;
                break;
            case 'isFirstEd':
                this.isFirstEd = !!value;
                break;
            default:
                console.log("tried setting invalid attribute \"".concat(attribute, "\" to article"));
        }
    };
    Article.prototype.toPlainObject = function () {
        return {
            quantity: this.quantity,
            condition: this.condition,
            idLanguage: this.idLanguage,
            price: this.price,
            isPlayset: this.isPlayset,
            isFirstEd: this.isFirstEd,
            isReverseHolo: this.isReverseHolo,
            isFoil: this.isFoil,
            isSigned: this.isSigned,
            isAltered: this.isAltered,
            comment: this.realComment,
            idArticle: this.idArticle,
            idProduct: this.idProduct,
        };
    };
    //used to discover exactly matching stock while listing
    Article.prototype.isSimiliar = function (article) {
        return (this.idProduct === article.idProduct &&
            this.idLanguage === article.idLanguage &&
            this.condition === article.condition &&
            this.isFoil == article.isFoil &&
            this.isPlayset == article.isPlayset &&
            this.isReverseHolo == article.isReverseHolo &&
            this.isSigned == article.isSigned &&
            this.isFirstEd == article.isFirstEd);
    };
    // Method
    Article.prototype.parseCardmarketArticle = function (cardmarketArticle) {
        var idProduct = cardmarketArticle.idProduct, condition = cardmarketArticle.condition, comments = cardmarketArticle.comments, count = cardmarketArticle.count, price = cardmarketArticle.price, isPlayset = cardmarketArticle.isPlayset, isReverseHolo = cardmarketArticle.isReverseHolo, isFirstEd = cardmarketArticle.isFirstEd, isFoil = cardmarketArticle.isFoil, isSigned = cardmarketArticle.isSigned, isAltered = cardmarketArticle.isAltered, language = cardmarketArticle.language, idArticle = cardmarketArticle.idArticle;
        return [
            Number(count),
            condition,
            Number(language.idLanguage),
            Number(idProduct),
            Number(price),
            comments,
            !!isFoil,
            !!isPlayset,
            !!isReverseHolo,
            !!isSigned,
            !!isFirstEd,
            idArticle,
            null,
            !!isAltered,
        ];
    };
    Article.prototype.parseStockResponseArticle = function (stockResponseArticle) {
        var idProduct = stockResponseArticle.idProduct, condition = stockResponseArticle.condition, comments = stockResponseArticle.comments, count = stockResponseArticle.count, price = stockResponseArticle.price, isPlayset = stockResponseArticle.isPlayset, isReverseHolo = stockResponseArticle.isReverseHolo, isFirstEd = stockResponseArticle.isFirstEd, isFoil = stockResponseArticle.isFoil, isSigned = stockResponseArticle.isSigned, isAltered = stockResponseArticle.isAltered, idLanguage = stockResponseArticle.idLanguage, idArticle = stockResponseArticle.idArticle;
        return [
            Number(count),
            condition,
            Number(idLanguage),
            Number(idProduct),
            Number(price),
            comments,
            !!isFoil,
            !!isPlayset,
            !!isReverseHolo,
            !!isSigned,
            !!isFirstEd,
            idArticle,
            null,
            !!isAltered,
        ];
    };
    return Article;
}());
exports.Article = Article;
//# sourceMappingURL=Article.js.map